/**
 * getElement
 */
export default (val, field = "entityId", defaultData = null) => {
  return val && val[field] ? val[field] : defaultData;
};
